export function useActionStatus(messages) {
    const getNextMessage = (index) => messages.value[index + 1] ?? null;

    const isToolResult = (msg, rejected = false) => {
        if (!msg.isToolResult && msg.typeChunk !== 'TOOL') return false;

        const content = msg.content;
        if (content && typeof content === 'object' && 'success' in content) {
            return rejected ? !content.success : content.success;
        }

        return false;
    };

    const getActionStatus = (index) => {
        const next = getNextMessage(index);
        if (!next) return 'pending';
        if (isToolResult(next, true)) return 'rejected';
        if (isToolResult(next, false)) return 'confirmed';
        if (next.role === 'assistant') return 'confirmed';
        return 'idle';
    };

    return { getActionStatus };
}
